import Vue from 'vue'

import colHeader from './component-column-header'
Vue.component(colHeader.name, colHeader)

import rowCell from './component-row-cell'
Vue.component(rowCell.name, rowCell)

export default {
    slots() {
        return [
            {
                slot: "column-default",
                component: colHeader.name,
                condition(attrs) {
                    return attrs.col.type === 'ComponentColumn' && attrs.col.header.component !== undefined
                }
            },
            {
                slot: "row-cell",
                component: rowCell.name,
                condition(attrs) {
                    return attrs.col.type === 'ComponentColumn' && attrs.col.content.component !== undefined
                }
            }
        ]
    }
}
